module.exports = __webpack_public_path__ + "img/orders white.02050905.svg";